// removed by extract-text-webpack-plugin
module.exports = {"container":"_2j1E-LrsJgJ4Q9emmo1jKV","header":"HB4coBjVh2xNv2EzA6EGB","searchContainer":"_1JUEHkraUHHcCC1YQuEv9m","addContainer":"_2s7VxdUnB1XC6L7NojyBGk","addBtn":"_1JeSLCR0d8VOviqypB2Dc_"};


//////////////////
// WEBPACK FOOTER
// ./src/Root/pages/Groups/style/Groups.pcss
// module id = 1371
// module chunks = 0